import { ThunkAction } from 'redux-thunk'

import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { TransactionType } from 'admin/types'
import createApiReducer, { requestDataFor, receiveDataFor, handleErrorFor } from 'redux/utils/createApiDuck'
import { APIState } from 'types'

const moduleName = `${config.appName  }/transaction`

export default createApiReducer(moduleName)

export function fetchTransaction(transactionId: string): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.getTransaction(transactionId)
      .then(data => dispatch(receiveDataFor(moduleName)(data)))
      .catch(error => dispatch(handleErrorFor(moduleName)(error)))
  }
}

export interface TransactionState extends APIState {
  data: TransactionType,
}
